import { clientApi } from 'api';
import { IArticle } from 'server/models/Article/types';

export const addArticle = (isServer = false) => async (data: FormData) =>
  await clientApi.post<IArticle>('/blog', data);
export const sendImageArray = (isServer = false) => async (images: FormData) =>
  await clientApi.post<string[]>(`/blog/image-array/`, images);
